import { getLabel } from "@weapp/utils";

export const i18n = {
    notAuth: () => getLabel('142973', '对不起，您暂时没有权限！'),
    defaultSearchPlaceholder: () => getLabel('216943', '请输入'),
    tip: () => getLabel('127698', '小提示'),

    tip_message: {
        confirm_delete: () => getLabel('142974', '确定要删除吗？')
    },

    holder_message: {
        common_condition: () => getLabel('142975', '请输入条件')
    },
    83936: () => getLabel('142976', '请输入姓名/首字母/全拼/电话/编号'),
    40137: () => getLabel('142977', '邀请同事'),
    batchImport: () => getLabel('116567', '批量导入'),
    batchExport: () => getLabel('142978', '批量导出'),
    batchAdd: () => getLabel('142979', '批量添加'),
    40140: () => getLabel('142980', '人员导出'),
    custField: () => getLabel('142981', '自定义列'),
    10433: () => getLabel('142982', '从其他部门移入'),
    opLog: () => getLabel('92642', '操作日志'),
    help: () => getLabel('109484', '帮助'),
    setting: () => getLabel('99585', '设置'),
    search: () => getLabel('142983', '搜索'),
    resetDefaultSetting: () => getLabel('61799', '恢复默认设置'),
    40145: () => getLabel('142984', '解散群组'),
    10757: () => getLabel('142985', '编辑部门'),
    createSuccess: () => getLabel('142986', '增加成功'),

    saveSuccess: () => getLabel('101297', '保存成功'),
    optSuccess: () => getLabel('92559', '操作成功'),
    settingSuccess: () => getLabel('61320', '设置成功'),
    updateSuccess: () => getLabel('143000', '修改成功'),
    modifySuccess: () => getLabel('109463', '更新成功'),
    40147: () => getLabel('143001', '确定要删除部门吗？删除后将无法恢复'),
    deleteSuccess: () => getLabel('61245', '删除成功'),
    40149: () => getLabel('143002', '群组编辑'),
    40150: () => getLabel('143003', '确认退出群组？'),
    40151: () => getLabel('143004', '退出群组成功'),
    40152: () => getLabel('143005', '确认解散群组？'),
    40153: () => getLabel('143006', '解散群组成功'),
    all: () => getLabel('124180', '全部'),
    40155: () => getLabel('143007', '导入本地excel'),
    batchDelete: () => getLabel('99519', '批量删除'),
    11327: () => getLabel('143008', '岗位结构'),
    14444: () => getLabel('143009', '岗位名称'),
    edit: () => getLabel('216941', '编辑'),
    create: () => getLabel('99518', '新建'),
    delete: () => getLabel('99524', '删除'),
    save: () => getLabel('60609', '保存'),
    saveAs: () => getLabel('99523', '另存为'),
    ok: () => getLabel('91355', '确定'),//getLabel('60675', '确认'),
    cancel: () => getLabel('69026', '取消'),
    close: () => getLabel('131067', '关闭'),
    confirm: () => getLabel('109451', '信息确认'),
    1463: () => getLabel('143010', '编辑岗位'),
    40165: () => getLabel('143011', '确定要删除岗位吗？删除后将清除人员信息中的该岗位信息'),
    40166: () => getLabel('143012', '确定移除选中人员吗？'),

    1403: () => getLabel('143035', '职级设置'),
    1468: () => getLabel('143036', '删除职级'),
    40172: () => getLabel('143037', '人员职级详情'),
    40173: () => getLabel('143038', '职级名称不能为空'),
    40174: () => getLabel('143039', '确定要删除职级吗？'),
    40175: () => getLabel('143040', '查看{$1}的资料'),
    1927: () => getLabel('143041', '人员名称设置'),
    40181: () => getLabel('143042', '1.最多支持设置5个字段;'),
    40182: () => getLabel('143043', '2.开启开关后，组织架构人员名称将按照设置的规则展示;'),
    40183: () => getLabel('143044', '启用人员名称自定义扩展:'),
    40184: () => getLabel('143045', '名称扩展规则'),
    40185: () => getLabel('143046', '默认规则：人员名称 + 部门 + 岗位'),
    40186: () => getLabel('143047', '新增+'),
    40187: () => getLabel('99521', '预览'),
    40188: () => getLabel('143048', '存在重复的字段'),
    40192: () => getLabel('143049', '矩阵列表'),
    40194: () => getLabel('143050', '矩阵名称'),
    disable: () => getLabel('101306', '禁用'),
    enable: () => getLabel('61107', '启用'),
    dataMaintain: () => getLabel('143051', '数据维护'),
    40199: () => getLabel('143052', '添加字段'),
    40200: () => getLabel('143053', '您还未设置矩阵字段'),
    40201: () => getLabel('143054', '添加行'),
    40202: () => getLabel('143055', '删除行'),
    employee: () => getLabel('69338', '人员'),
    department: () => getLabel('143056', '部门'),
    group: () => getLabel('143057', '群组'),
    40203: () => getLabel('143058', '新建矩阵'),
    40204: () => getLabel('143059', '人员矩阵设置'),
    40205: () => getLabel('143060', '{$1}矩阵'),
    40206: () => getLabel('61103', '删除后不可恢复,确定删除吗？'),
    40208: () => getLabel('143061', '启用成功'),
    40209: () => getLabel('143062', '停用成功'),
    fieldMaintain: () => getLabel('143063', '字段维护'),
    40211: () => getLabel('143064', '矩阵字段设置'),
    40239: () => getLabel('143065', '人事档案设置'),
    40240: () => getLabel('143066', '数据预览:'),
    40241: () => getLabel('143067', '是否包含离职人员'),
    60261: () => getLabel('143068', '接口'),
    60262: () => getLabel('143069', '按钮'),
    221: () => getLabel('143070', '权限设置'),
    60305: () => getLabel('143071', '$页面中的按钮级权限项'),
    60306: () => getLabel('143072', '$页面中的接口级权限项'),
    60307: () => getLabel('143073', '添加接口级权限项'),
    60308: () => getLabel('143074', '请选择需要添加的数据'),
    60309: () => getLabel('143075', '请选择需要删除的数据'),

    60310: () => getLabel('143076', '确认要删除所选择的数据吗？'),
    60312: () => getLabel('143077', '查看引用:$'),
    83: () => getLabel('143078', '全部展开'),
    84: () => getLabel('143079', '全部收缩'),
    exportData: () => getLabel('143080', '导出'),
    60372: () => getLabel('143081', '角色列表'),
    79: () => getLabel('143082', '角色信息'),
    4057759: () => getLabel('143083', '功能权限'),
    76: () => getLabel('143084', '成员设置'),
    60373: () => getLabel('143085', '新建角色'),
    88: () => getLabel('143086', '添加成员'),
    60374: () => getLabel('143087', '编辑成员'),
    deleteConfirm: () => getLabel('60952', '确认要删除吗?'),
    60376: () => getLabel('143088', '确认要删除选择的成员吗?'),
    60468: () => getLabel('143089', '其他权限设置'),
    60473: () => getLabel('143090', '指定成员'),
    60596: () => getLabel('143091', '确认要恢复默认设置吗？'),
    61528: () => getLabel('143092', '上一步'),
    61529: () => getLabel('92362', '下一步'),
    61530: () => getLabel('71145', '完成'),
    61531: () => getLabel('143093', '数据预览'),
    61532: () => getLabel('143094', '上传Excel'),
    61534: () => getLabel('143095', '导入数据'),
    61535: () => getLabel('143096', '请上传文件'),
    61537: () => getLabel('143097', '上传文件'),
    61538: () => getLabel('143098', '可直接拖动文件到这里上传'),
    batchDeleteConfirm: () => '123'
}